import { Divider } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import AddIcon from '@material-ui/icons/Add';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import RemoveIcon from '@material-ui/icons/Delete';
import DropDownIcon from '@material-ui/icons/VerticalAlignBottom';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { getEnvVariable } from '../../../modules/environmentalList';
import { GetData, PostData } from '../helpers/requests';
import { OldPostMutiFormData } from '../../../core/controls/helpers/requests';
import DefaultSettings from './settings';
import { useParams, withRouter } from 'react-router-dom';


export default function MultipleFileUpload({ edit, fieldValues, props, ismultiple = true, name, IsFilenet = false, ischildAttachments = false, value, handleFieldValue }) {

    if (ischildAttachments)
        ischildAttachments = getEnvVariable('AllowChildDocuments') === "Y" ? true : false;
    const [multiplefiles, setMultipleFiles] = useState(value || [])
    // const [NoteView, setNoteView] = useState(props.dataItem || [])
    const fileInput = useRef(null)
    const params = useParams()

    useEffect(() => {
        setMultipleFiles(value)
    }, [value])

    const handleFileUpload = (event) => {
        let file = []
        event.preventDefault();
        if (fileInput && fileInput.current) {
            const fname = fileInput.current.files[0].name;
            const size = fileInput.current.files[0].size;
            toBase64(event)
                .then(result => {
                    var e = {
                        target: {
                            name: fname,
                            value: result
                        }
                    }
                    let attach = result.split(',')
                    if (attach.length === 2)
                        file.push({ UploadType: 'U', ContentStr: attach[1], FileName: fname, Size: size, FileType: attach[0] });
                    let files = [...multiplefiles, ...file];

                    //500MB
                    if (size > 500000000) { //change to 5 MB
                        if (DefaultSettings.getAlert() != null && alert)
                            DefaultSettings.getAlert().show('Uploading size exceeded 500MB', 'error');
                    } else {
                        setMultipleFiles(files)
                        let events = { target: { value: files, name: name, checked: false }, currentTarget: { dataset: null } }
                        handleFieldValue(events);
                    }

                }).catch(ex => console.log(ex));
        }
    }
    const uploadFile = (e, parentid, childid) => {// parent parameter
        let files = e.target.files;
        if (files && files.length > 0) {
            uploadFileWrapper(files, parentid, childid);
        }
    }/*  */

    const uploadFileWrapper = (files, parentid) => {
        let paramId = params.routeid1 || params.Id
        let url = getEnvVariable('Sidebar') + `/api/FileSystem/${paramId ? paramId +
            '/Upload' : 'Upload'}?${params.routeid1 ? 'parentid=' + params.routeid1 : ''}&sitePermitTypeId=
            ${params.routeid ? params.routeid : 0}&attachmentType=${fieldValues['AttachmentTypeId'] || 0}`;
        let predetails = []
        var formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('files', files[i], files[i].name);
        }
        OldPostMutiFormData(url, formData, true, true, '').then(response => {
            let res = response
            if (res && res.length > 0)
                for (let i = 0; i < res.length; i++) {
                    let pdobj = {
                        FileName: res[i].fileName, ContentType: res[i].fileName.split(".").pop(), Size: res[i].size, FileReference: res[i].fileReference,
                        fileName: res[i].fileName, extension: files[i].type, fileType: files[i].type, guid: res[i].fileReference, size: res[i].size,

                    }
                    if (parentid) {
                        pdobj.ParentAttachmentDetailId = parentid;
                    }
                    predetails.push(pdobj);
                }
            let events = {}
            if (!parentid) {
                events = { target: { value: [...multiplefiles, ...predetails], name: name, checked: false }, currentTarget: { dataset: null } }
            } else {
                events = { target: { value: [...multiplefiles, ...predetails], name: name, checked: false }, currentTarget: { dataset: null } }
            }
            //console.log(events)
            handleFieldValue(events);

        }).catch(ex => {
            console.error(ex)
        })
    }


    const toBase64 = (event) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        })
    };


    const handleSimpleDelete = (i,url) => {
        let tempfiles = multiplefiles.filter((each, index) => {
            return each.Id !== i
        })
        let events = { target: { value: tempfiles, name: name, checked: false }, currentTarget: { dataset: null } }
        GetData(url).then(resp => {
            if (resp) {                
                if (DefaultSettings.getAlert() != null && alert)
                    DefaultSettings.getAlert().show('Attachment removed successfully', 'success');
                setMultipleFiles(tempfiles)
                handleFieldValue(events);
            }
        })
    }
    const handleDelete = (file) => {
        console.log(file);
        if (file.FileReference) {
            const fileData = {
                "fileReference": file.FileReference,
                "contentType": file.FileType || 'pdf',//||'xlsx',.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf,.csv,.zip
                "folder": "Attachments",
                "fileName": file.FileName,
                "Id": file.Id
            }
            
            handleSimpleDelete(file.Id,getEnvVariable('Sidebar') + `/api/Attachments/RemoveFile/${file.Id}`)
            // PostData(getEnvVariable('Sidebar') + `/api/File/RemoveFile/${file.Id}`, fileData).then(dlteref => {
            //     if (dlteref && dlteref.FileId) {                    
            //         handleSimpleDelete(dlteref.FileId,getEnvVariable('Sidebar') + `/api/Files/RemoveFile/${dlteref.FileId}`)
            //     }
            // })

        }
        else if (file.Id > 0) { //#/Administration/companies
            handleSimpleDelete(file.Id,getEnvVariable('Admin') + `/api/Files/RemoveFile/${file.Id}`)
        }
    }

    const DownloadAttachment = (Name, linkSource, ContentStr, filetype) => {
        if (!linkSource)
            linkSource = filetype + ContentStr;
        const downloadLink = document.createElement("a");
        const fileName = Name;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    //    const downloadAttachments = (Id) => {
    //     const isSidebar = true;
    //     //const url = isSidebar ? getEnvVariable('Sidebar')+ `/api/UPSDocumentsAttachment/DownloadFile/${Id}` : getEnvVariable('Admin') + `/api/Files/DownloadFile/${Id}`;
    //     const url = isSidebar ? getEnvVariable('Sidebar') + `/api/FileSystem/${Id}/DownloadRef`: getEnvVariable('Admin') + `/api/Files/DownloadFile/${Id}`;
    //         if (Id >= 0) {//getEnvVariable('Admin') + `/api/Files/DownloadFile/${Id}`||
    //             PostData(url).then(resp => {
    //                 console.log(resp);
    //                 if (resp && resp.FileId) {
    //                     DownloadAttachment(resp.FileName, resp.ContentStr, resp.FileType)
    //                 }
    //             })
    //         }
    //     }
    const downloadAttachments = (file) => {
        console.log(file);
        if (file.FileReference) {
            const fileData = {
                "fileReference": file.FileReference,
                "contentType": file.FileType || 'pdf',//||'xlsx',.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf,.csv,.zip
                "folder": "Attachments",
                "fileName": file.FileName,
                "Id": file.Id
            }
            PostData(getEnvVariable('Sidebar') + `/api/FileSystem/${file.Id}/DownloadRef`, fileData).then(dldref => {
                if (dldref && dldref.FileId) {
                    DownloadAttachment(file.FileName, getEnvVariable('Sidebar') + `/api/FileSystem/DownloadContent/${dldref.FileId}`)
                    // GetData(getEnvVariable('Sidebar') + `/api/FileSystem/DownloadContent/${dldref.FileId}`).then(resp => {
                    //     if (resp && resp.FileId) {
                    //         DownloadAttachment(resp.FileName, resp.ContentStr, resp.FileType)
                    //     }
                    // })
                }
            })

        }
        else if (file.Id > 0) { //#/Administration/companies
            GetData(getEnvVariable('Admin') + `/api/CompanyFiles/Download/${file.Id}`).then(resp => {
                if (resp && resp.FileId) {
                    DownloadAttachment(file.FileName, getEnvVariable('Admin') + `/api/CompanyFiles/DownloadContent/${resp.FileId}`)
                }
            })
        }
    }

    console.log(IsFilenet);
    return (
        <div className='col-12 row m-2' style={{ height: '500px', overflow: 'auto' }}>
            <Paper elevation={1} className="col-12">
                {multiplefiles && multiplefiles.length === 0 && <div className="text-center ">
                    <AttachFileIcon color="default" style={{ fontSize: '80px' }} /><br />
                    <div classes="text-secondary">No attachments have been added</div><br />
                    {edit && <Button variant="contained" component="label" color="primary"> <AddIcon /> Add Attachment
                        <input
                            type="file"
                            ref={fileInput}
                            onChange={(e) => IsFilenet === true ? uploadFile(e) : handleFileUpload(e)}
                            accept=".doc,.docx,.pdf,.txt,.xls,.xlsx"
                            hidden
                        />
                    </Button>}
                </div>
                }
                {multiplefiles && multiplefiles.length > 0 &&
                    <div>
                        <h6 className="pt-4 col fw-bold">Attachments&nbsp;&nbsp;
                            {/* {multiplefiles && multiplefiles.length > 0 && <IconButton edge="end" color="primary" onClick={() => zipAttachDownload()}>
                                <ArchiveIcon />
                            </IconButton>} */}
                        </h6>
                        <br />
                        <Divider />
                        {edit && ismultiple && <Button component="label" > <AddIcon color="primary" /> Add Attachment
                            <input
                                type="file"
                                ref={fileInput}
                                onChange={IsFilenet === true ? uploadFile : handleFileUpload}
                                accept=".doc,.docx,.pdf,.txt,.xls,.xlsx"
                                hidden
                            />
                        </Button>}
                        <Divider /></div>
                }
                {multiplefiles && multiplefiles.length > 0 && <Fragment>
                    {/* <List>
                        <ListItem dense >
                            <ListItemText alignItems="flex-start" ><Typography component="span"
                                variant="subtitle2"
                                color="primary">Name</Typography> </ListItemText>
                            <ListItemSecondaryAction>
                                <Typography component="span"
                                    variant="subtitle2"
                                    color="primary">Actions</Typography>
                            </ListItemSecondaryAction>
                        </ListItem>
                    </List> */}
                    {/* <Divider /> */}
                    <List> <Paper elevation={1} className="col-12">
                        {(multiplefiles || []).map((file, i) => {
                            let childAttachments = (multiplefiles || []).filter((each, index) => {
                                if (each.ParentAttachmentDetailId)
                                    return each.ParentAttachmentDetailId === file.Id
                            })
                            return <ListItem key={i} dense ><Paper elevation={0} className="col-12">
                                {ischildAttachments && file.ParentAttachmentDetailId == null && <ListItemText alignItems="flex-start">{file.FileName || file.Id || 'Document ' + (i + 1)}

                                    <span className='float-end'> {edit && file.Id &&
                                        ischildAttachments === true && <IconButton size='small' edge="end" color="primary" component="label" >
                                            <AddIcon className='float-end ' size="small" />
                                            <input
                                                type="file"
                                                className='float-end'
                                                ref={fileInput}
                                                onChange={(e) => IsFilenet == true ? uploadFile(e, file.Id) : handleFileUpload(file.Id)}
                                                accept=".doc,.docx,.pdf,.txt,.xls,.xlsx"
                                                hidden
                                            />
                                        </IconButton>
                                    }
                                        {file.Id && <IconButton size='small' edge="end" color="primary" onClick={() => { downloadAttachments(file) }}>
                                            <DropDownIcon />
                                        </IconButton>}
                                        {edit && file.Id && <IconButton size='small' edge="end" color="secondary" onClick={() => handleDelete(file)}>
                                            <RemoveIcon />
                                        </IconButton>}
                                    </span>


                                    {(childAttachments || []).map((childdocuments, i) => {
                                        return <ListItem key={i} dense ><Paper elevation={1} className="col-12">
                                            <ListItemText alignItems="flex-start">{childdocuments.FileName || childdocuments.Id || 'Document ' + (i + 1)} </ListItemText>
                                            <ListItemSecondaryAction>
                                                {childdocuments.Id && <IconButton size="small" edge="end" color="primary" onClick={() => downloadAttachments(childdocuments)}>
                                                    <DropDownIcon />
                                                </IconButton>}
                                                {edit && childdocuments.Id && <IconButton size="small" edge="end" color="secondary" onClick={() => handleDelete(childdocuments)}>
                                                    <RemoveIcon />
                                                </IconButton>}
                                            </ListItemSecondaryAction></Paper>
                                        </ListItem>
                                    })}
                                </ListItemText>
                                }
                            </Paper></ListItem>
                        })}
                        {!ischildAttachments && multiplefiles && multiplefiles.length > 0 && <Fragment>
                            <List>
                                <ListItem dense >
                                    <ListItemText alignItems="flex-start" ><Typography component="span"
                                        variant="subtitle2"
                                        color="primary">Name</Typography> </ListItemText>
                                    <ListItemSecondaryAction>
                                        <Typography component="span"
                                            variant="subtitle2"
                                            color="primary">Actions</Typography>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            </List>
                            <Divider />
                            <List>
                                {(multiplefiles || []).map((file, i) => {
                                    return <ListItem key={i} dense >
                                        <ListItemText alignItems="flex-start">{file.FileName || file.Id || 'Document ' + (i + 1)} </ListItemText>
                                        <ListItemSecondaryAction>
                                            {file.Id && <IconButton size="small" edge="end" color="primary" onClick={() => downloadAttachments(file)}>
                                                <DropDownIcon />
                                            </IconButton>}
                                            {edit && file.Id && <IconButton size="small" edge="end" color="secondary" onClick={() => handleDelete(file)}>
                                                <RemoveIcon />
                                            </IconButton>}
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                })}
                            </List>
                        </Fragment>
                        }
                        {/* //{(multiplefiles || []).map((childdocuments, i) => { */}
                        {/* // return <ListItem key={i} dense >
                                    //     <ListItemText alignItems="flex-start">{childdocuments.FileName || childdocuments.Id || 'Document ' + (i + 1)} </ListItemText>
                                    //     <ListItemSecondaryAction>
                                            
                                    //         <IconButton edge="end" color="primary" onClick={() => downloadAttachments(childdocuments)}>
                                    //             <DropDownIcon />
                                    //         </IconButton>
                                    //         {edit && <IconButton edge="end" color="secondary" onClick={() => handleDelete(childdocuments.Id)}>
                                    //             <RemoveIcon />
                                    //         </IconButton>}
                                    //     </ListItemSecondaryAction>
                                    //     {
                                    //         /*
                                    //         no display for the added child docs
                                    //         */
                            //     }
                            // </ListItem>
                            //}) */}
                        }


                    </Paper></List>
                </Fragment>
                }
            </Paper>
        </div >



    );
}

